import setDefaultOptions from 'date-fns/setDefaultOptions';
import type { Locale } from 'date-fns';
import '@angular/localize/init';
import { registerLocaleData } from '@angular/common';
import { moment } from '../moment';
import type { LanguageConfig } from './config';
import {
  ANGULAR_LOCALE_IMPORTS,
  DEFAULT_LANGUAGE,
  DEFAULT_LANGUAGE_CONFIG,
  getLanguageConfig,
} from './config';
import type { LanguageCode } from './config';

let registerLocalePromise: Promise<void> = Promise.resolve();
let locale: string = '';

async function registerLocale(config: LanguageConfig): Promise<void> {
  const localeImport = ANGULAR_LOCALE_IMPORTS[config.code as LanguageCode];
  if (localeImport) {
    const module = await localeImport();
    registerLocaleData(module.default);
  }
  moment.locale(config.momentLocale);
  setDefaultOptions({ locale: config.dateFnsLocale });
}

export function getRegisterLocalePromise(): Promise<void> {
  return registerLocalePromise;
}

export function getLocale(): string {
  if (locale) return locale;

  const paths = window.location.pathname.split('/');
  let l: string | null = paths[paths.length - 2];
  const isLocaleFound = getLanguageConfig(l as LanguageCode) !== undefined;

  if (isLocaleFound) return l;
  else if (typeof URLSearchParams === 'function') {
    const urlParams = new URLSearchParams(window.location.search);
    l = urlParams.get('locale');
  }

  return l || DEFAULT_LANGUAGE;
}


locale = getLocale();

const initialConfig = getLanguageConfig(locale);
if (initialConfig && initialConfig.code !== DEFAULT_LANGUAGE) {
  registerLocalePromise = registerLocale(initialConfig);
} else {
  moment.locale(DEFAULT_LANGUAGE_CONFIG.momentLocale);
  setDefaultOptions({ locale: DEFAULT_LANGUAGE_CONFIG.dateFnsLocale });
}


export function getNzLocale() {
  const config = getLanguageConfig(getLocale());
  return config?.nzI18n ?? DEFAULT_LANGUAGE_CONFIG.nzI18n;
}

export function getNzDateLocale(): Locale {
  const config = getLanguageConfig(getLocale());
  return config?.dateFnsLocale ?? DEFAULT_LANGUAGE_CONFIG.dateFnsLocale;
}

export function isLocaleFrench() {
  return (getLocale() === 'fr-CA');
}

export function isLocaleEnglish() {
  return (getLocale() === 'en-US');
}

export function isLocaleSpanish() {
  return (getLocale() === 'es-MX');
}

export function getLocaleForAdaChatbot(): string {
  const config = getLanguageConfig(getLocale());
  return config?.adaChatbotLocale ?? DEFAULT_LANGUAGE_CONFIG.adaChatbotLocale;
}

export function getHelpCenterLocale(): string {
  const config = getLanguageConfig(getLocale());
  return config?.helpCenterLocale ?? DEFAULT_LANGUAGE_CONFIG.helpCenterLocale;
}

export function getThoughtSpotLocale(): string {
  const config = getLanguageConfig(getLocale());
  return config?.thoughtSpotLocale ?? DEFAULT_LANGUAGE_CONFIG.thoughtSpotLocale;
}

export function getLocaleForBulkEdits(): string {
  const config = getLanguageConfig(getLocale());
  return config?.bulkEditsLocale ?? DEFAULT_LANGUAGE_CONFIG.bulkEditsLocale;
}
